export default {
  root: {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF9800'
    }
  },
  notchedOutline: {
    borderColor: 'rgba(0,0,0,0.15)'
  }
};
